import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/about-ripple.png'


const _withScopeId = n => (_pushScopeId("data-v-2bfadf09"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"overflow":"hidden"},
  class: "relative"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "bg-image top d-none d-md-block"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "bg-image bottom d-none d-md-block"
}, null, -1))
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 지구를 지키는 재사용, 재활용, 업사이클 "),
    /*#__PURE__*/_createElementVNode("div", { class: "video-wrapper" }, [
      /*#__PURE__*/_createElementVNode("iframe", {
        width: "100%",
        height: "100%",
        src: "https://www.youtube.com/embed/apnO1yUcm60",
        title: "YouTube video player",
        frameborder: "0",
        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: ""
      })
    ])
  ])
], -1))
const _hoisted_6 = { class: "next-button-wrapper" }

import { onMounted } from 'vue';
  import TabTitle from './academy-title.vue';
  import NextButton from './next-button.vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(TabTitle, {
      title: "해양 쓰레기, 영상으로 들여다 보기",
      step: "STEP 03."
    }),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(NextButton, { class: "relative" })
      ])
    ])
  ]))
}
}

})